import { render, staticRenderFns } from "./addBid.vue?vue&type=template&id=1673dc02&scoped=true"
import script from "./addBid.vue?vue&type=script&lang=js"
export * from "./addBid.vue?vue&type=script&lang=js"
import style0 from "./addBid.vue?vue&type=style&index=0&id=1673dc02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673dc02",
  null
  
)

export default component.exports